import type { CatalogItemsFilterConfig } from "../catalog/posCard";

/**
 * `recommendations/constants` — the flow's fixed values, in one place so a second UI does not
 * re-invent them.
 */

/** The provider id reported for the V2 recommendation engine. */
export const RISTA_AI_V2_PROVIDER = "RISTA_AI_V2";

/**
 * The one V1 provider with different fetch semantics: it is re-queried on ANY cart change and is
 * sent the whole cart, where every other V1 provider is queried only when a new item is added and
 * is sent just that item.
 */
export const RISTA_FBT_PROVIDER = "RISTA_FBT";

/** How many recommendations a surface shows by default. Override per surface if it has room. */
export const DEFAULT_RECOMMENDATION_LIMIT = 3;

/**
 * The catalogue filters a recommendation must pass before it is shown.
 *
 * All six are ON: a suggestion the terminal cannot actually sell — wrong channel, outside its
 * schedule, sold out, no price — is worse than no suggestion, because the guest has already been
 * told about it by the time the till refuses. `resolveVariantToParent` is what makes a
 * recommended VARIANT open its parent's customiser rather than being dropped.
 */
export const RECOMMENDATION_CATALOG_FILTER: CatalogItemsFilterConfig = {
  resolveVariantToParent: true,
  scheduleAvailability: true,
  validPrice: true,
  channelEligibility: true,
  excludeSoldOuts: true,
};
